import React from "react";
import { useFormik } from "formik";
import { IUploadContract } from "../../interfaces/others/IUploadContract.ts";
import { SaveFileSchema } from "../../validation/schemas/SaveFileSchema.ts";
import CustomInput from "../formik/CustomInput.tsx";
import { notification } from "../../utils/Notifications.tsx";
import Loader from "../Loader.tsx";
import {
  getEntryDateImss,
  saveEntryDateImss,
} from "../../services/colaborador.pdf.service.ts";
import moment from "moment";

const SaveImssDate: React.FC<IUploadContract> = ({ partner, closeFn }) => {
  const [loading, setLoading] = React.useState<boolean>(true);

  const formik = useFormik({
    initialValues: { date: null },
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const date = moment(values.date).format("YYYY-MM-DD");
        const response = await saveEntryDateImss(partner.id, date);

        notification("Éxito", "Contrato subido correctamente", "success");
      } catch (error) {
        notification(
          "Error",
          "Ocurrió un error al actualizar la fecha",
          "danger"
        );
      } finally {
        setLoading(false);
        closeFn();
      }
    },
  });

  const fetchData = async () => {
    try {
      const response = await getEntryDateImss(partner.id);

      if (response?.date) {
        const date = moment(response.date).format("YYYY-MM-DD");
        formik.setFieldValue("date", date);
      }
      if (response?.date === null) {
        const today = moment().format("YYYY-MM-DD");
        formik.setFieldValue("date", today);
      }
    } catch (error) {
      notification("Error", "Ocurrió un error al obtener los datos", "danger");
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <CustomInput
        smLabel={3}
        sm={9}
        type="date"
        field="date"
        formik={formik}
        label="Fecha"
      />
      <div className="d-flex justify-content-end">
        <button className="btn btn-secondary me-2" onClick={() => closeFn()}>
          Cancelar
        </button>
        <button className="btn btn-azul" onClick={() => formik.handleSubmit()}>
          Guardar
        </button>
      </div>
      <Loader isLoading={loading} />
    </React.Fragment>
  );
};

export default SaveImssDate;
